import { render, staticRenderFns } from "./CampaignFormModal.vue?vue&type=template&id=2c36386a&scoped=true"
import script from "./CampaignFormModal.vue?vue&type=script&lang=js"
export * from "./CampaignFormModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignFormModal.vue?vue&type=style&index=0&id=2c36386a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36386a",
  null
  
)

export default component.exports